import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../utilities/TabGrid";
import TopExportCSV from "../../../../componentsTopsa/exportCSV/TopExportCSV";
import acc from 'accounting'

export default class UrzadRaportSumarycznyTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            wszystkieKolumnyEksport: [
                {value: "nr_linii", label: 'Nr linii'},
                {value: "nazwa_linii", label: 'Nazwa linii'},
                {value: "ilosc", label: 'Ilość'},
                {value: "wart_bil_brutto", label: 'Wartość biletu brutto'},
                {value: "wart_bil_netto", label: 'Wartość biletu netto'},
                {value: "wart_dopl_brutto", label: 'Wartość dopłaty brutto'},
                {value: "wart_dopl_netto", label: 'Wartość dopłaty netto'},
            ],
            kolumnyDoExportuDefault: [
                {value: "nr_linii", label: 'Nr linii'},
                {value: "nazwa_linii", label: 'Nazwa linii'},
                {value: "ilosc", label: 'Ilość'},
                {value: "wart_bil_brutto", label: 'Wartość biletu brutto'},
                {value: "wart_bil_netto", label: 'Wartość biletu netto'},
                {value: "wart_dopl_brutto", label: 'Wartość dopłaty brutto'},
                {value: "wart_dopl_netto", label: 'Wartość dopłaty netto'},
            ],
        };

    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextprops) {
    }

    formatCena(cell, row) {
        return acc.formatMoney(cell)
    }

    
    render() {
        const options = {
            noDataText: 'Brak pasujących rekordów',
        };


        return (
            <div>
                <div>
                    <TopExportCSV daneRest={this.props.data} wszystkieKolumny={this.state.wszystkieKolumnyEksport}
                                  kolumnyDoExportu={this.state.kolumnyDoExportuDefault}/>
                </div>
                <div>
                    <div className={'pull-right'} style={{fontSize: '12px', color: 'grey', padding: '5px', fontStyle: 'italic'}}>
                        Ilość wyszukanych rekordów: {Boolean(this.props.data) ? this.props.data.length : 0}
                    </div>
                </div>
                <div>
                    <BootstrapTable data={this.props.data}
                                    options={options}
                                    hover
                    >
                        <TableHeaderColumn dataField='nr_linii' isKey dataSort
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                        >Linia nr</TableHeaderColumn>
                        <TableHeaderColumn dataField='nazwa_linii' dataSort
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                        >Nazwa linii</TableHeaderColumn>
                        <TableHeaderColumn dataField='ilosc' dataSort
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                        >Ilość</TableHeaderColumn>
                        <TableHeaderColumn dataField='wart_bil_brutto' dataSort
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           dataFormat={this.formatCena}
                        >Wart. biletu brutto</TableHeaderColumn>
                        <TableHeaderColumn dataField='wart_bil_netto' dataSort
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           dataFormat={this.formatCena}
                        >Wart. biletu netto</TableHeaderColumn>
                        <TableHeaderColumn dataField='wart_dopl_brutto' dataSort
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           dataFormat={this.formatCena}
                        >Wart. dopłaty brutto</TableHeaderColumn>
                        <TableHeaderColumn dataField='wart_dopl_netto' dataSort
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           dataFormat={this.formatCena}
                        >Wart. dopłaty netto</TableHeaderColumn>
                    </BootstrapTable>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/urzadModule/raport_sumaryczny/components/UrzadRaportSumarycznyTable.js